<template>
  <div class="lh-box" :class="endOn">
  	<!--加载动画-->
	<div class="lh-loading-new learning">
		<audio id="loadingAudio" src="style/img/loading/anisound.mp3"></audio>
		<div style="background-image:url(style/img/loading/spelling.png)"></div>
	</div>
  	<!--learning-->
	<div class="lh-return" data-type="return" data-path="/customs1" @click="gotoNext($event)"><img src="style/img/return.png" /></div>
	<div class="lh-page lh-learning cover" :class="learningShow" style="background-image:url(style/img/writing/writing-bg.png);" @touchstart.prevent.stop="seesawStart($event)" @touchmove.prevent.stop="isMove?seesawMove($event):''">
		<div class="lh-writing-icon" :class="writing[checkingIndex].class"><img :src="writing[checkingIndex].text" /></div>
		<div class="lh-writing-bd"></div>
		<div class="lh-writing-img" :data-class="writing[checkingIndex].class" :class="writing[checkingIndex].class">
			<img :src="writing[checkingIndex].img" />
			<span class="dot" v-for="item in writing[checkingIndex].dot"></span>
		</div>
		<div class="dot1"></div>
		<ul class="lh-writing-hd">
			<li v-for="(item,index) in writing" :class="item.hover"></li>
		</ul>
	</div>
	<div class="lh-learning-audio">
    	<audio id="Slide_sound" src="style/img/learning/sound/ep1-writing-time.mp3"></audio>
        <audio id="Success" src="style/img/learning/sound/ep1_LT_1.mp3"></audio>
        <audio id="Success1" src="style/img/checking/sound/success.mp3"></audio>
        <audio id="slide" src="style/img/learning/sound/slide.mp3"></audio>
        <audio id="swing" src="style/img/learning/sound/swing.mp3"></audio>
        <audio id="seesaw" src="style/img/learning/sound/seesaw.mp3"></audio>
        <audio id="roundabout" src="style/img/learning/sound/roundabout.mp3"></audio>
        <audio id="endAudio" src="style/img/learning/sound/end.mp3"></audio>
        <audio id="good" src="style/img/checking/sound/success.mp3"></audio>
    </div>
    <!--ending-->
	<div class="lh-checking"><div>
		<div class="lh-checking-a1"><img src="style/img/checking/end-a1.png" /></div>
		<div class="lh-checking-a2"><img src="style/img/checking/end-a2.png" /></div>
		<div class="lh-checking-a6 qiqiu"><img src="style/img/checking/end-a6.png" /></div>
		<div class="lh-checking-a5 qiqiu"><img src="style/img/checking/end-a5.png" /></div>
		<div class="lh-checking-a4 qiqiu"><img src="style/img/checking/end-a4.png" /></div>
	</div></div>
  </div>
</template>
<style type="text/css" scoped>
	
</style>
<script>
export default{
	data(){
		return {
			learningShow:'',
			checkingIndex:0,
			endOn:'',
			writing:[
				{img:'style/img/writing/slide.png',text:'style/img/writing/slide-icon.png',class:'slide',hover:'on',dot:35,area:[]},
				{img:'style/img/writing/seesaw.png',text:'style/img/writing/seesaw-icon.png',class:'seesaw',hover:'',dot:57,area:[]},
				{img:'style/img/writing/swing.png',text:'style/img/writing/swing-icon.png',class:'swing',hover:'',dot:40,area:[]},
				{img:'style/img/writing/roundabout.png',text:'style/img/writing/roundabout-icon.png',class:'roundabout',hover:'',dot:76,area:[]}
			],
			isMove:true,
			dotNum:0,
			className:'slide'
		}
	},
	created(e){
		var that=this;
	},
	mounted(e){
		var that=this;
		that.loadingPage();
		that.loading();
		that.getArea();
	},
	methods:{
		loadingPage(e){
			setTimeout(function(){
				$('.lh-loading-new>div').css({'animation-play-state':'paused'});
			},1000);
			setTimeout(function(){
				$('.lh-loading-new>div').css({'animation-play-state':'running'});
			},2000);
		},
		//获取固定区域
		getArea(e){
			var that=this,wWidth=$(window).height(),wHeight=$(window).width();
			setTimeout(function(){
				for(var i=0;i<$('.dot').length;i++){
					var _left=$($('.dot')[i]).offset().left,_top=$($('.dot')[i]).offset().top;
					var _width=$($('.dot')[i]).height(),_height=$($('.dot')[i]).width();
					var _left1=_left,_top1=_top,
					_right1=_left+_width,
					_top1=_top,
					_bottomg1=_top+_height;
					that.writing[that.checkingIndex].area.push({left1:_left1,right1:_right1,top1:_top1,bottom1:_bottomg1});
				}
				that.dotNum=that.writing[that.checkingIndex].dot;
			},1000);
		},
		seesawStart(e){
			var that=this,idx=$(e.currentTarget).data('idx');
			var startX=e.changedTouches[0].pageX,startY=e.changedTouches[0].pageY;
			//起始位置
			that.writing[that.checkingIndex].start={x:startX,y:startY};
			var x=startX,y=startY;
			var dotNum=that.dotNum;
			for(var i=0;i<that.writing[that.checkingIndex].dot;i++){
				if(x>=that.writing[that.checkingIndex].area[i].left1&&x<=that.writing[that.checkingIndex].area[i].right1&&y>=that.writing[that.checkingIndex].area[i].top1&&y<=that.writing[that.checkingIndex].area[i].bottom1){
					if(!$($('.dot')[i]).hasClass('hover')){
						$('#Success')[0].play();
						$($('.dot')[i]).addClass('hover');
						dotNum--;
						that.dotNum=dotNum;
						if(dotNum==0){
							that.dotNum=0;
							$('#'+that.className)[0].play();
							that.endAudio($('#'+that.className)[0]);
						}
					}
				}
			}
		},
		seesawMove(e){
			var that=this;
			var y=e.changedTouches[0].pageY;
			var x=e.changedTouches[0].pageX;
			that.writing[that.checkingIndex].pageY=y;
			that.writing[that.checkingIndex].pageX=x;
			var dotNum=that.dotNum;
			for(var i=0;i<that.writing[that.checkingIndex].dot;i++){
				if(x>=that.writing[that.checkingIndex].area[i].left1&&x<=that.writing[that.checkingIndex].area[i].right1&&y>=that.writing[that.checkingIndex].area[i].top1&&y<=that.writing[that.checkingIndex].area[i].bottom1){
					if(!$($('.dot')[i]).hasClass('hover')){
						$('#Success')[0].play();
						$($('.dot')[i]).addClass('hover');
						dotNum--;
						that.dotNum=dotNum;
						if(dotNum==0){
							that.dotNum=0;
							$('#'+that.className)[0].play();
							that.endAudio($('#'+that.className)[0]);
						}
					}
				}
			}
		},
		seesawEnd(e){
			var that=this,idx=$(e.currentTarget).data('idx');
			var endX=e.changedTouches[0].pageX,endY=e.changedTouches[0].pageY;
			//that.practicinghd[idx].endX=that.practicinghd[idx].pageX;
			//that.practicinghd[idx].endY=that.practicinghd[idx].pageY;
		},
		gotoNext(e){
			var that=this,path=$(e.currentTarget).data('path'),type=$(e.currentTarget).data('type');
			if(type==='return'){
				that.learningShow="";
				that.$router.replace({ path: path})
			}else if(type==='slide'){
				$('#Slide')[0].play();
				that.endAudio(path,$('#Slide')[0]);
			}
		},
		endAudio(e){
			var that=this,checkingIndex=that.checkingIndex;
			if(e==null || e.paused){
				if(checkingIndex<3){
					$('.lh-page').addClass('Writing');
					setTimeout(function(){
						that.checkingIndex+=1;
						if(that.checkingIndex==1){
							that.className="seesaw"
						}else if(that.checkingIndex==2){
							that.className="swing"
						}else if(that.checkingIndex==3){
							that.className="roundabout"
						}
						$('.lh-page').removeClass('Writing');
						for(var i=0;i<that.writing;i++){
							that.writing.hover="";
						}
						$('.dot').removeClass('hover');
						that.getArea();
						that.writing[that.checkingIndex].hover="on";
					},800)
				}else{
					that.endAnimate();
				}
			}
			e.addEventListener("ended",function(){
				if(checkingIndex<3){
					$('.lh-page').addClass('Writing');
					setTimeout(function(){
						that.checkingIndex+=1;
						if(that.checkingIndex==1){
							that.className="seesaw"
						}else if(that.checkingIndex==2){
							that.className="swing"
						}else if(that.checkingIndex==3){
							that.className="roundabout"
						}
						$('.lh-page').removeClass('Writing');
						for(var i=0;i<that.writing;i++){
							that.writing.hover="";
						}
						$('.dot').removeClass('hover');
						that.getArea();
						that.writing[that.checkingIndex].hover="on";
					},800)
				}else{
					that.endAnimate();
				}
			});
		},
		endAnimate(){
			var that=this;
			that.endOn="End";
			$('#good')[0].play();
			that.qiqiuAnimate();
		},
		qiqiuAnimate(e){
			var that=this,num=true;
			setTimeout(function(){
				TweenMax.staggerTo($('.qiqiu'),1,{bezier:{type:"cubic", values:[{x:30,y:150,opacity:0},{x:-20,y:50,opacity:1},{x:0,y:10,opacity:1},{x:0,y:-10,opacity:0}], autoRotate:true},onComplete(e){
					if(num){
						this.restart(true, false);
						num=false;
					}else{
						that.$router.replace({ path: '/customs1'});
					}
				}},.5);	
			},1000);
		},
		loading(e){
			var that=this,loadingImg=that.loadingImg;
			sessionStorage.setItem("start",'{"idx":"4","path":"/writing","type":""}');
			$('#loadingAudio')[0].play();
			that.learning()
		},
		learning(e){
			var that=this;
			setTimeout(function(){
				//$('#Slide_sound')[0].play();
				if($('#Slide_sound')[0]==null || $('#Slide_sound')[0].paused){
					that.learningShow="Learning";
				}
				$('#Slide_sound')[0].addEventListener("ended",function(){
					that.learningShow="Learning";
				})	
			},2950)
		}
	}
}
</script>
<style>
    .lh-checking {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, .5);
        z-index: 1000;
        opacity: 0;
        visibility: hidden;
        transition: cubic-bezier(0.215, .61, .355, 1) .45s;
    }

    .lh-checking > div {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        width: 49.6875%;
        bottom: -8%;
    }

    .lh-checking-a1 {
        width: 100%;
        transform: translateY(100%);
        visibility: hidden;
        transition: cubic-bezier(0.215, .61, .355, 1) .45s;
        position: relative;
        z-index: 2;
    }

    .lh-checking > div > div:not(:first-child) {
        position: absolute;
    }

    .lh-checking-a2 {
        width: 61.433962%;
        left: 0;
        bottom: 40.023201856148494%;
        opacity: 0;
        transition: cubic-bezier(0.215, .61, .355, 1) 1s;
        transform: translate(-30vw, 10vw);
    }

    .lh-checking-a3 {
        width: 21.48846960167715%;
        right: 0;
        bottom: 39.21113689095127%;
        opacity: 0;
        transform: translate(-20vw, -10vw);
    }

    .lh-checking-a4 {
        width: 4.926624737945493%;
        left: 25.681341719077565%;
        bottom: 77.7262180974478%;
        transform: translate(5vw, 30vw);
        opacity: 0;
    }

    .lh-checking-a5 {
        width: 6.918238993710692%;
        left: 27.9874213836478%;
        bottom: 87.70301624129931%;
        transform: translate(5vw, 30vw);
        opacity: 0;
    }

    .lh-checking-a6 {
        width: 5.765199161425576%;
        left: 20.440251572327046%;
        bottom: 93.96751740139212%;
        transform: translate(5vw, 30vw);
        opacity: 0;
    }
    .End .lh-checking{opacity: 1; visibility: visible;}
    .End .lh-checking-a1{transform:translateY(0); visibility: visible;}
    .End .lh-checking-a1 img{ animation: ending1 linear 2s infinite; transform-origin: center 60%;}
    .End .lh-checking-a2{opacity: 1;transform: translate(0,0); transition-delay: 1s;}
    .End .lh-checking-a2 img{ animation: ending2 linear 2s infinite;}
    .End .lh-checking-a3{opacity: 1;transform: translate(0,0); transition-delay: 1s;}
    .End .lh-checking-a3 img{ animation: ending2 linear 2s infinite;}
</style>
